import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import '../styles/Hero.css';

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-background">
        <img
          src="/images/global-connectivity.jpg"
          alt="Global connectivity and worldwide staffing"
          className="hero-bg-image"
        />
      </div>
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <h1 className="hero-title">
          Your Trusted Partner for <span className="highlight">Global Staffing</span>
        </h1>
        <p className="hero-subtitle">
          Connecting exceptional talent with outstanding opportunities worldwide.
          Your trusted partner for customized staffing solutions.
        </p>
        <div className="hero-buttons">
          <Link to="/for-employers" className="btn btn-primary">
            For Employers <FaArrowRight className="btn-icon" />
          </Link>
          <Link to="/for-job-seekers" className="btn btn-secondary">
            For Jobseekers <FaArrowRight className="btn-icon" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Hero;
